export default "__VITE_ASSET__39b5e2cc__"